import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalRules } from 'ui-product-approvals-common';
import { ApprovalRulesRadioGroup } from './ApprovalRulesRadioGroup';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalRulesRadio = ({
  approvalRule = ApprovalRules.NON_SEQUENTIAL,
  onChangeApprovalRule,
  isOrderedApprovalSteps = false
}) => /*#__PURE__*/_jsx(ApprovalRulesRadioGroup, {
  name: "productApprovalsApprovalRules",
  required: true,
  value: approvalRule,
  onChange: onChangeApprovalRule,
  hasOrderedApprovalSteps: isOrderedApprovalSteps,
  label: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "productApprovals.ApprovalRules.radioHeading"
  })
});